import * as React from "react";
import { UitkHeading, UitkText } from "uitk-react-text";
import {
  UitkMessagingCard,
  UitkMessagingCardMedia,
  UitkMessagingCardImageLayout,
  UitkMessagingCardSection,
} from "uitk-react-messaging-cards";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkIllustrations } from "uitk-react-illustrations";
import { UitkLink } from "uitk-react-link";
import { useLocalization } from "@shared-ui/localization-context";
import { FlexClickTracker } from "src/components/utility/analytics/FlexClickTracker/FlexClickTracker";

interface PriceTrendGraphAnchorProps {
  location: string;
  locationType: string;
}

/* istanbul ignore next */
const scrollTo = (): void => {
  const priceTrendElement = document.getElementById("price-trend-graph-1");

  if (priceTrendElement) {
    // Should remove wizard-hotel-pwa-1 or wizard-hotel-pwa-v2-1 after the wizard experiment done
    const wizardElement =
      document.getElementById("wizard-hotel-pwa-1") ?? document.getElementById("wizard-hotel-pwa-v2-1");

    const wizardHeight = wizardElement ? wizardElement.offsetHeight + wizardElement.offsetTop : 0;

    window.scrollTo({
      top:
        priceTrendElement.getBoundingClientRect().top + window.pageYOffset - wizardHeight - priceTrendElement.offsetTop,
      behavior: "smooth",
    });
    priceTrendElement.focus();
  }
};

export const PriceTrendGraphAnchor: React.FC<PriceTrendGraphAnchorProps> = (props: PriceTrendGraphAnchorProps) => {
  const LinkTracked = FlexClickTracker(UitkLink);
  const { formatText } = useLocalization();
  const { location, locationType } = props;

  const anchorTitle =
    locationType === "multi_city_vicinity"
      ? formatText("priceTrendGraph.anchor.title.city", location)
      : formatText("priceTrendGraph.anchor.title.country", location);
  const anchorSubtitle =
    locationType === "multi_city_vicinity"
      ? formatText("priceTrendGraph.anchor.subtitle.city", location)
      : formatText("priceTrendGraph.anchor.subtitle.country", location);
  const moreDetailsText = formatText("priceTrendGraph.anchor.moreDetails");
  const illustrationAlt = formatText("priceTrendGraph.anchor.alt");

  return (
    <UitkSpacing margin={{ blockstart: "three" }}>
      <UitkMessagingCard className="PriceTrendGraphAnchor" imageLayout={UitkMessagingCardImageLayout.LEFT}>
        <UitkMessagingCardMedia>
          <UitkIllustrations
            alt={illustrationAlt}
            url="https://a.travel-assets.com/uds/illustrations/price_trend__negative.svg"
          />
        </UitkMessagingCardMedia>
        <UitkMessagingCardSection>
          <UitkHeading level={3} size={300}>
            {anchorTitle}
          </UitkHeading>
          <UitkText size={300} weight="regular">
            {anchorSubtitle}
          </UitkText>
          <UitkSpacing margin={{ blockstart: "two" }}>
            <div>
              <LinkTracked
                rfrr="TG.LP.Hotels.PriceTrendGraph.Anchor"
                onClick={scrollTo}
                moduleName="PriceTrendGraphAnchor"
                linkName="RFRR Action Event"
                inline={true}
              >
                <button type="button" onClick={scrollTo}>
                  {moreDetailsText}
                </button>
              </LinkTracked>
            </div>
          </UitkSpacing>
        </UitkMessagingCardSection>
      </UitkMessagingCard>
    </UitkSpacing>
  );
};

export default PriceTrendGraphAnchor;
